import { useCallback } from 'react'

import set from 'lodash/set'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { isUserSupply } from 'Components/utils/roles'

export const MAX_DIFFERENCE_FACTOR = 0.5

const useReception = () => {
  const { t } = useTranslation()
  const user = useSelector(({ auth }) => auth.user)

  const getIsExtraService = useCallback(el => {
    if (el.isServicioExtra || (el.extraServiceDescription && el.extraServiceDescription !== '')) {
      return true
    }
    return false
  }, [])

  const getDifferenceEstimatedWithReception = useCallback(
    (line, totalReception) => {
      if (getIsExtraService(line)) {
        if (!line.extraServiceDescription) {
          return { isExtraService: true, isBigDifference: false, difference: 0 }
        }
        const linePrice = line.extraServicePrice || line.price || 0

        const difference = Math.abs(totalReception - linePrice)
        const okDifference = MAX_DIFFERENCE_FACTOR * linePrice
        if (difference > okDifference) {
          return { isExtraService: true, isBigDifference: true, difference }
        }

        return { isExtraService: true, isBigDifference: false, difference }
      }
      return { isExtraService: false, isBigDifference: false, difference: 0 }
    },
    [getIsExtraService]
  )

  const validateReception = useCallback(
    (receptionlines, lines) => {
      const errors = {}
      if (receptionlines && lines) {
        receptionlines.forEach((rline, index) => {
          if (!rline.priceUnit && rline.amount > 0) {
            set(errors, `receptionlines[${index}].priceUnit`, t('priceUnit0error'))
          }
          const { isBigDifference, isExtraService } = getDifferenceEstimatedWithReception(
            lines[index],
            rline?.priceUnit
          )
          if (isExtraService && isBigDifference && !isUserSupply(user)) {
            set(errors, `receptionlines[${index}].priceUnit`, 'Error')
          }
        })
      }

      return errors
    },
    [getDifferenceEstimatedWithReception, t, user]
  )

  return {
    getDifferenceEstimatedWithReception,
    validateReception,
    getIsExtraService,
  }
}

export default useReception
